import type { CustomFoodMigrationDocType } from '../validators';
import type { Assert, AssertEqual } from './type-assertions';
import type { ExtractDocumentTypeFromTypedRxJsonSchema, RxJsonSchema } from 'rxdb';
import { defineRxdbCollectionModel } from './migration';

// ============================================================================
// RxDB collection schema for customFoodMigrations.
//
// Document shape mirrors the D1 `custom_food_migrations` row. This collection
// is PULL-ONLY: the server is authoritative. The client push handler returns
// an empty conflicts array (no-op) so RxDB push is a safe no-op.
//
// `customFoodIsShared` is a server-computed field included in pull docs.
// ============================================================================

export const CUSTOM_FOOD_MIGRATIONS_COLLECTION = 'customFoodMigrations' as const;
export const CUSTOM_FOOD_MIGRATIONS_SCHEMA_VERSION = 0;

export const customFoodMigrationsSchemaLiteral = {
  title: 'custom food migrations schema',
  version: CUSTOM_FOOD_MIGRATIONS_SCHEMA_VERSION,
  primaryKey: 'id',
  type: 'object',
  properties: {
    id: { type: 'string', maxLength: 100 },
    userId: { type: 'string', maxLength: 100 },
    customFoodId: { type: 'string', maxLength: 100 },
    customFoodName: { type: 'string', maxLength: 500 },
    systemFoodId: { type: 'string', maxLength: 100 },
    systemFoodName: { type: 'string', maxLength: 500 },
    status: {
      type: 'string',
      enum: ['pending', 'applied', 'ignored'],
    },
    customFoodIsShared: { type: 'boolean' },
    createdAt: { type: 'string', maxLength: 30 },
    updatedAt: { type: 'string', maxLength: 30 },
  },
  required: ['id', 'userId', 'customFoodId', 'customFoodName', 'systemFoodId', 'systemFoodName', 'status', 'customFoodIsShared', 'createdAt', 'updatedAt'],
  indexes: [['userId', 'updatedAt']],
} as const;

export interface CustomFoodMigrationsCheckpoint {
  updatedAt: string;
  id: string;
}

type _CustomFoodMigrationSchemaDocType = ExtractDocumentTypeFromTypedRxJsonSchema<typeof customFoodMigrationsSchemaLiteral>;
type _CustomFoodMigrationDocTypeInSync = Assert<AssertEqual<_CustomFoodMigrationSchemaDocType, CustomFoodMigrationDocType>>;

export const customFoodMigrationsSchema: RxJsonSchema<CustomFoodMigrationDocType> = customFoodMigrationsSchemaLiteral;
export const customFoodMigrationsModel = defineRxdbCollectionModel<typeof CUSTOM_FOOD_MIGRATIONS_COLLECTION, CustomFoodMigrationDocType>({
  collection: CUSTOM_FOOD_MIGRATIONS_COLLECTION,
  schema: customFoodMigrationsSchema,
});
